// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.scss']
// })
// export class AppComponent {
//   title = 'Vizient Application';
// }
import { Component, OnInit } from '@angular/core';
import { CustomOktaAuthService } from './auth/oktaauth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'NRP Dashboard';

  constructor(
    private okta: CustomOktaAuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.okta.autoAuthUser();
  }
}

